import React, { useState, useEffect } from "react";
import { Parallax } from "react-scroll-parallax";

const About = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const getSpeed = (desktopSpeed) =>
    isMobile ? desktopSpeed * 0.3 : desktopSpeed;

  return (
    <section
      className="relative px-4 sm:px-6 lg:px-8 overflow-hidden"
      style={{
        paddingTop: "clamp(6rem, 15vw, 12rem)",
        paddingBottom: "clamp(8rem, 18vw, 15rem)",
      }}
    >
      {/* Background Floating Orbs */}
      <Parallax
        speed={getSpeed(-20)}
        className="absolute pointer-events-none"
        style={{ right: "5%", top: "10%" }}
      >
        <div
          style={{
            width: "clamp(150px, 30vw, 300px)",
            height: "clamp(150px, 30vw, 300px)",
            background:
              "radial-gradient(circle, rgba(6, 182, 212, 0.2) 0%, transparent 70%)",
            borderRadius: "50%",
            filter: "blur(60px)",
          }}
        ></div>
      </Parallax>

      <Parallax
        speed={getSpeed(15)}
        className="absolute pointer-events-none"
        style={{ left: "10%", bottom: "20%" }}
      >
        <div
          style={{
            width: "clamp(120px, 25vw, 250px)",
            height: "clamp(120px, 25vw, 250px)",
            background:
              "radial-gradient(circle, rgba(20, 184, 166, 0.15) 0%, transparent 70%)",
            borderRadius: "50%",
            filter: "blur(50px)",
          }}
        ></div>
      </Parallax>

      <div className="max-w-7xl mx-auto w-full">
        {/* Title */}
        <Parallax
          speed={getSpeed(-15)}
          translateY={isMobile ? [10, -10] : [30, -30]}
        >
          <h2
            className="font-normal mb-6 sm:mb-8 md:mb-12 bg-gradient-to-r from-[#009999] via-white to-white bg-clip-text text-transparent"
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "clamp(32px, 5vw, 60px)",
              lineHeight: "1.2",
              letterSpacing: "0.17em",
            }}
          >
            About Us
          </h2>
        </Parallax>

        {/* Description */}
        <Parallax
          speed={getSpeed(10)}
          translateY={isMobile ? [-8, 8] : [-20, 20]}
        >
          <p
            className="text-gray-300"
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontSize: "clamp(16px, 2.5vw, 30px)",
              lineHeight: "1.6",
              letterSpacing: "0.17em",
              maxWidth: "100%",
            }}
          >
            Heyareweare is a next generation Creative technology company that
            blends Artificial Intelligence, Extended Reality (AR, VR, MR), and
            enterprise IT services to create intelligent, immersive, and
            enterprise grade solutions. From Media to Retail to Enterprises, we
            help businesses unlock growth by reimagining how people and
            technology connect.
          </p>
        </Parallax>
      </div>
    </section>
  );
};

export default About;
